/**
 * Site-wide popup + content config provider.
 * Fetches /api/site/settings once at app load and exposes it via `useSiteSettings()`.
 */
import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const Ctx = createContext(null);

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    let alive = true;
    axios.get(`${API_URL}/api/site/settings`)
      .then((r) => { if (alive) setSettings(r.data); })
      .catch(() => { /* fall back to component defaults */ });
    return () => { alive = false; };
  }, []);
  return <Ctx.Provider value={settings}>{children}</Ctx.Provider>;
}

export function useSiteSettings() {
  return useContext(Ctx);
}
